export const UnitSystemModel = function (data) {
    if (!data) data = {};
    this.unitSytem = data.UNIT_SYSTEM || [];
    this.imperialOption = data.IMPERIAL ||[];
    this.metricOption = data.METRIC ||[];
};